import React, {useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {columnsFactory} from "./statements-list.columns";
import {Button, Space} from "antd";
import {filtersFactory} from "./statements-list.filters";
import {StatementsListInfo} from "./statements-list.info";
import {filterButtonsFactory} from "./statements-list.filter-buttons";
import {ComponentPropsFromRoute} from "../../../../routers/routers";
import {Statement, StatementSummary} from "../../../../models/accounting/client-statements";
import {FilterDataHandler} from "../../../../models/filter/filter.data.handler";
import {statementsService} from "../../../../services/accounting/client-statements.service";
import {LoadingSpin} from "../../../common/loading-spin/loading.spin";
import FilteredTable from "../../../common/filtered-table/filtered.table";
import {Export} from "../../../common/export/export";
import {useRequiredStore} from "../../../../utils/store";
import {AgentDataStoreContext} from "../agent.data.store";

interface AgentDataStatementsListProps extends ComponentPropsFromRoute {}

export const AgentDataStatementsList: React.FC<AgentDataStatementsListProps> = () => {

    const {account} = useRequiredStore(AgentDataStoreContext);

    const {t} = useTranslation("translation", {useSuspense: false});

    const [summary, setSummary] = useState<StatementSummary | null>(null);

    const dataHandler: FilterDataHandler<Statement> = useMemo(() => new FilterDataHandler(request => statementsService.getList(account?.id!, request)), []);

    const columns = useMemo(() => columnsFactory(t, summary?.currencyCode || ""), []);
    const filters = useMemo(() => filtersFactory(t), []);
    const filterButtons = useMemo(() => filterButtonsFactory(t), []);

    const [exportModalShown, setExportModalShown] = useState<boolean>(false);

    useEffect(() => {
        statementsService.getSummary(account?.id!).then(summary => setSummary(summary))
    }, []);

    if (!summary) {
        return <LoadingSpin />
    }

    return (
        <Space direction={"vertical"} size={[30, 30]}>
            <StatementsListInfo summary={summary} />
            <FilteredTable
                columns={columns}
                dataHandler={dataHandler}
                filterKeys={filters}
                filterButtons={filterButtons}
                buttons={[
                    <Button
                        type={"primary"}
                        onClick={() => setExportModalShown(true)}
                    >{t("EXPORT.TITLE")}</Button>
                ]}
            />
            {exportModalShown ? (
                <Export
                    title={"ACCOUNTING.STATEMENTS.TITLE"}
                    isShown={true}
                    withBasicExportFields
                    config={{
                        link: "/api/v3/accounts/" + account?.id! + "/statements",
                        query: dataHandler.lastRequest?.toParams()
                    }}
                    onClose={() => setExportModalShown(false)}
                />
            ) : null}
        </Space>
    )
}